import { useIsomorphicLayoutEffect } from "@react-hookz/web";

import { setGTMCustomDimension } from "~/components/tracking/google-tag-manager/apis";
import { useCanonicalUrl } from "~/lib/hooks";
import { isBotUserAgent } from "~/lib/utils";

export const useInitTrackingSetup = () => {
  const { canonicalUrl: canonicalURL } = useCanonicalUrl();
  const isBot = isBotUserAgent();

  useIsomorphicLayoutEffect(() => {
    const data = {
      canonicalURL,
      isBot,
    };
    // Use for the events before page view sent
    setGTMCustomDimension(data);
  }, [canonicalURL, isBot]);
};
